import { CommApiInstance } from "Utils/CommApiInstance";

const NickNameChngApi = async (
    nickname:string,
    recaptchaToken:string
) => {
    return await CommApiInstance.post(`memb/nickname/chng`,{
        apiBody:{
            nickname:nickname,
            cptchTkn:recaptchaToken
        },
    })
    .then((Resp) => Resp.data);
}
export default NickNameChngApi;